export default {"src":"/_next/static/media/stars.16f88c1d.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};